import { DateTimePicker } from "@mui/x-date-pickers/DateTimePicker";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { TextField } from "@mui/material";

type IProps = {
  formik: any;
  name: string;
  label: string;
};

const FormikDateTimePicker: React.FC<IProps> = ({ formik, name, label }) => {
  console.log("formik.values[name]", formik.values[name]);
  return (
    <LocalizationProvider dateAdapter={AdapterDateFns}>
      <DateTimePicker
        label={label}
        value={formik.values[name] || null}
        onChange={(date: any) => {
          console.log("date: ", date);
          formik.setFieldValue(name, date);
        }}
        renderInput={(params: any) => <TextField {...params} fullWidth />}
      />
    </LocalizationProvider>
  );
};

export default FormikDateTimePicker;
